import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import auth from './modules/auth'
import integrations from './modules/integrations'
import businesses from './modules/businesses'
import locations from './modules/locations'
import stats from './modules/stats'
import listings from './modules/listings'
import reviews from './modules/reviews'
import local_recon_widgets from './modules/local_recon_widgets'
import me from './modules/me'

import users from './modules/users'

import activity from './modules/activity'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth']
})

export default new Vuex.Store({
  modules: {
    auth,
    integrations,
    businesses,
    locations,
    stats,
    listings,
    reviews,
    local_recon_widgets,
    me,
    activity,
    users
  },
  state: {},
  mutations: {},
  actions: {},
  plugins: [vuexLocal.plugin]
})